import React, {PureComponent} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {
    Form,
    Input,
    InputNumber,
    Select,
    AutoComplete,
    DatePicker,
    Button,
    Card,
    Row,
    Col,
    notification,
    Spin,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import Request from '../../../request'
import {hideLoader, showLoader} from '../../../modules/actions'
import {connect} from 'react-redux'
import {goBack} from 'connected-react-router'

const {Option} = Select
const {TextArea} = Input

@Form.create()
class AddProductionOrderForm extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            loader: true,
            products: [],
        }
    }

    componentDidMount() {
        this.loadProducts()

        let searchParams = new URLSearchParams(this.props.search)
        let id = searchParams.get('id')

        if (id) {
            Request.getProductionOrderFormById({_id: id}).then(({data, error}) => {
                if (!error && data) {
                    this.setState({_id: data._id, loader: false})
                    this.props.form.setFieldsValue({
                        productionOrderId: data.productionOrderId,
                        createdDate: data.createdDate ? moment(data.createdDate) : null,
                        expectedCompletionDate: data.expectedCompletionDate ? moment(data.expectedCompletionDate) : null,
                        product: data.product,
                        quantity: data.quantity,
                        unitOfMeasurement: data.unitOfMeasurement,
                        priority: data.priority,
                        productionTeam: data.productionTeam,
                        remarks: data.remarks,
                    })
                } else {
                    this.setState({loader: false})
                    notification.error({message: 'Error Getting Data'})
                }
            })
        } else {
            Request.getNextProductionOrderId().then((d) => {
                if (!d.error) {
                    this.props.form.setFieldsValue({productionOrderId: d.data})
                }
            })
            this.props.form.setFieldsValue({createdDate: moment(), priority: 'Normal'})
            this.setState({loader: false})
        }
    }

    // Products come from the stock-product master (same source as Move To Stock)
    loadProducts = () => {
        Request.getStockProductMaster({results: 2000}).then((res) => {
            const list = !res ? [] : Array.isArray(res) ? res : res.data || res.products || []
            this.setState({products: list})
        })
    }

    // block any date before today (past dates are not selectable)
    disabledDate = (current) => {
        return current && current < moment().startOf('day')
    }

    // val is the product name (selected from the list or typed in freely)
    onSelectProduct = (val) => {
        const p = this.state.products.find((x) => x.name === val)
        if (p && p.unit) {
            this.props.form.setFieldsValue({unitOfMeasurement: p.unit})
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()
        const {form, dispatch} = this.props
        form.validateFieldsAndScroll(async (err, valData) => {
            if (err) return
            let values = _.clone(valData)

            // value is the product name (existing or newly typed); attach the
            // master product id when it matches an existing one
            const typed = (values.product || '').trim()
            values.product = typed
            const prod = this.state.products.find((x) => x.name === typed)
            values.productId = prod ? prod._id : undefined

            dispatch(showLoader())
            let x
            if (this.state._id) {
                values._id = this.state._id
                x = await Request.updateProductionOrderForm(values)
            } else {
                x = await Request.addProductionOrderForm(values)
            }
            dispatch(hideLoader())

            if (!x.error) {
                notification.success({message: x.message})
                if (this.state._id) {
                    dispatch(goBack())
                } else {
                    form.resetFields()
                    form.setFieldsValue({createdDate: moment(), priority: 'Normal'})
                    Request.getNextProductionOrderId().then((d) => {
                        if (!d.error) {
                            form.setFieldsValue({productionOrderId: d.data})
                        }
                    })
                }
            } else {
                notification.error({message: 'Error Saving', description: x.message})
            }
        })
    }

    render() {
        const {form: {getFieldDecorator}} = this.props
        const {products, _id} = this.state

        const formItemLayout = {
            labelCol: {xs: {span: 24}, sm: {span: 8}},
            wrapperCol: {xs: {span: 24}, sm: {span: 14}},
        }

        return (
            <PageHeaderWrapper title={_id ? 'Update Production Order' : 'Add Production Order'}>
                <Spin spinning={this.state.loader}>
                    <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                        <Card bordered={true}>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label='Production Order Id' {...formItemLayout}>
                                        {getFieldDecorator('productionOrderId')(
                                            <Input disabled/>
                                        )}
                                    </Form.Item>

                                    <Form.Item label='Created Date' {...formItemLayout}>
                                        {getFieldDecorator('createdDate', {
                                            rules: [{required: true, message: 'This is a Mandatory Field'}],
                                        })(
                                            <DatePicker
                                                style={{width: '100%'}}
                                                format='DD-MM-YYYY'
                                                disabledDate={this.disabledDate}
                                            />
                                        )}
                                    </Form.Item>

                                    <Form.Item label='Expected Completion Date' {...formItemLayout}>
                                        {getFieldDecorator('expectedCompletionDate', {
                                            rules: [{required: true, message: 'This is a Mandatory Field'}],
                                        })(
                                            <DatePicker
                                                style={{width: '100%'}}
                                                format='DD-MM-YYYY'
                                                disabledDate={this.disabledDate}
                                            />
                                        )}
                                    </Form.Item>

                                    <Form.Item label='Product' {...formItemLayout}>
                                        {getFieldDecorator('product', {
                                            rules: [{required: true, message: 'This is a Mandatory Field'}],
                                        })(
                                            <AutoComplete
                                                allowClear
                                                placeholder='Select or type a product'
                                                onSelect={this.onSelectProduct}
                                                filterOption={(input, option) =>
                                                    String(option.props.value || '')
                                                        .toLowerCase()
                                                        .indexOf(String(input || '').toLowerCase()) !== -1
                                                }
                                            >
                                                {products.map((p) => (
                                                    <Option key={p._id} value={p.name}>
                                                        {p.name}{p.productCode ? ` (${p.productCode})` : ''}
                                                    </Option>
                                                ))}
                                            </AutoComplete>
                                        )}
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item label='Quantity' {...formItemLayout}>
                                        {getFieldDecorator('quantity', {
                                            rules: [{required: true, message: 'This is a Mandatory Field'}],
                                        })(
                                            <InputNumber min={1} style={{width: '100%'}}/>
                                        )}
                                    </Form.Item>

                                    <Form.Item label='Unit of Measurement' {...formItemLayout}>
                                        {getFieldDecorator('unitOfMeasurement')(
                                            <Select placeholder='Unit' allowClear>
                                                <Option value='Kg'>Kg</Option>
                                                <Option value='Box'>Box</Option>
                                                <Option value='Piece'>Piece</Option>
                                            </Select>
                                        )}
                                    </Form.Item>

                                    <Form.Item label='Priority' {...formItemLayout}>
                                        {getFieldDecorator('priority', {
                                            rules: [{required: true, message: 'This is a Mandatory Field'}],
                                        })(
                                            <Select placeholder='Select priority'>
                                                <Option value='High'>High</Option>
                                                <Option value='Normal'>Normal</Option>
                                            </Select>
                                        )}
                                    </Form.Item>

                                    <Form.Item label='Production Team' {...formItemLayout}>
                                        {getFieldDecorator('productionTeam')(
                                            <Input placeholder='Production team'/>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24}>
                                    <Form.Item
                                        label='Remarks'
                                        labelCol={{xs: {span: 24}, sm: {span: 4}}}
                                        wrapperCol={{xs: {span: 24}, sm: {span: 18}}}
                                    >
                                        {getFieldDecorator('remarks')(
                                            <TextArea rows={3} placeholder='Write anything'/>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item style={{marginTop: 24, textAlign: 'center'}}>
                                <Button
                                    size='large'
                                    type='primary'
                                    htmlType='submit'
                                    loading={this.props.loading}
                                    style={{width: '15%', marginLeft: '1em'}}
                                >
                                    {_id ? 'Update' : 'Save'}
                                </Button>
                            </Form.Item>
                        </Card>
                    </Form>
                </Spin>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search,
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch,
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddProductionOrderForm)
